import React from 'react'
import ConsentForm from './forms/ConsentForm'
import DependentForm from './forms/DependentForm'
import { useAddDependent } from './hooks/provider'
import { FormStep } from './types'

const FormMap: Record<FormStep, React.ComponentType> = {
  [FormStep.INITIAL]: DependentForm,
  [FormStep.ADD_CHILD]: DependentForm,
  [FormStep.INVITE_ADULT]: DependentForm,
  [FormStep.GET_CONSENT]: ConsentForm,
} as const

const AddDependent = () => {
  const { addDependentForm } = useAddDependent()
  const { currentStep } = addDependentForm

  const FormComponent = FormMap[currentStep]
  return <FormComponent />
}

export default AddDependent
